module.exports = __webpack_public_path__ + "static/media/icon-pt.23c03a16.svg";